<div class="colour-spreader">
  <button mat-icon-button color="primary" [disabled]="!chosenColour" (click)="cancelClicked()"><mat-icon>cancel</mat-icon></button>
  @for (colour of availableColours; track colour) {
    <div class="swatch-item"
      [class.selected]="chosenColour===colour"
    [ngStyle]="{'background-color': colour}" (click)="colourPicked(colour)"></div>
  }
</div>